module.exports = __webpack_public_path__ + "img/hugol.2fc12589.jpeg";